import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { setHintCanShow } from '../../../../../../hints/effects/setHintCanShow';
import { EHintKey, EHintStatus } from '../../../../../../hints';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { editedNameCardIdSet } from '../../../../../../main/kanbanView/store/actions/editedNameCardIdSet';
import { getHint } from '../../../../../../hints/store/hints/selectors/getHint';

export const onClick = (
    cardId: TCardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_NAME_CLICKED));
        const hint = getHint(getState(), EHintKey.KANBAN_CARD_RENAME);
        if (hint.status === EHintStatus.NOT_SHOWN) {
            dispatch(setHintCanShow(EHintKey.KANBAN_CARD_RENAME, true));
            dispatch(editedNameCardIdSet(cardId));
        }
    };
    return action;
};
